import Productdetail from './productdetail.vue'
export default {
	name: 'productpage',
	components: {
		Productdetail
	},
	data() {
		return {
			idList: [],
			ineer_id: 0,
			inner_params: {}
		}
	},

	created(params) {
		const self = this;
		self.params = this.$route.params;
		self.ineer_id = this.$route.params.id;

		if (!this.idList.includes(parseInt(self.ineer_id))) {
			this.idList.push(parseInt(self.ineer_id));
			console.log('watchId', this.idList)
		};

		console.log('父组件', self.params, self.ineer_id);
		console.log('idList-1', self.idList)
	},
	mounted() {

	},
	computed: {
		token: function() {
			return this.$store.getters.getToken
		}
	},
	watch: {
		$route(to, from) {
			const self = this;
			self.params = this.$route.params;
			self.ineer_id = this.$route.params.id;

			if (!this.idList.includes(parseInt(self.ineer_id)) && self.ineer_id != undefined) {
				this.idList.push(parseInt(self.ineer_id));
			};


			console.log('父组件-2', self.params, self.ineer_id);
			console.log('idList-2', self.idList)
		},
	},
	methods: {


	},


}



// WEBPACK FOOTER //
// ./src/views/detail/productpage.js